export default __webpack_public_path__ + "static/media/Modalsearch.a1de22c0.svg";